import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { PaymentGatewatMaster, PaymentGatewatMasterList } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayMasterService {

  constructor(private http: HttpClient,) { }
  private BASE_URL: string = environment.BASE_URL;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  createPaymentGateway(tenantId: number, data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/pgw_config_master`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  enablePayengine(tenantId: number, data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/enable_pe`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updatePaymentGateway(tenantId: number, id: number, data: any) {
    return this.http
      .put(
        `${environment.BASE_URL}/tenants/${tenantId}/pgw_config_master/${id}`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentGatewayMasters(tenant_id: number): Observable<PaymentGatewatMasterList> {
    return this.http.get(`${environment.BASE_URL}/tenants/${tenant_id}/pgw_config_master`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentGatewayMasterById(tenantId: number,id:number) : Observable<PaymentGatewatMaster> {
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/pgw_config_master/${id}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentGatewayMasterHMAC(tenantId: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/pgw_config_master/hmac`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updatePaymentGatewayStatus(tenantId: number, id: number, status: string): Observable<any> {
    return this.http
      .post(
        `${this.BASE_URL}/tenants/${tenantId}/pgw_config_master/${id}/${status}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deletePaymentGateway(tenantId: number, id: number): Observable<any> {
    return this.http
      .delete(
        `${this.BASE_URL}/tenants/${tenantId}/pgw_config_master/${id}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
